import { useState } from 'react';
import { FormControl, Select, MenuItem, ListItemText, Checkbox } from '@mui/material';
import { useStyles } from './FilterSelectiveStyle';



const FilterSelective = ({
  onFilterChanged,
  columnDef,
  options,
  multiple = false,
  defaultFilter = null,
  ...rest
}) => {
  const [selected, setSelected] = useState(multiple ? [] : defaultFilter);
  const classes = useStyles();



  const handleChange = (e) => {
    const val = e.target.value;
    setSelected(val);

    if (!multiple) {
      onFilterChanged(columnDef.tableData.id, val.value);
    }
  };

  const onClose = (e) => {
    const val = selected.map((item) => item.value);
    onFilterChanged(columnDef.tableData.id, val);
  };

  return (
    <FormControl variant="outlined" className={classes.root} {...rest}>
      {multiple ? (
        <Select
          multiple
          value={selected ?? ''}
          onChange={handleChange}
          defaultValue=""
          onClose={onClose}
          renderValue={(val) => val.map((item) => item.label).join(', ')}
          fullWidth
          className='pureSelect'
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item}>
              <Checkbox checked={selected.map((e) => e.value).indexOf(item.value) > -1} />
              <ListItemText primary={item.label} />
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select
          value={selected ?? ''}
          onChange={handleChange}
          fullWidth
          defaultValue=""
          className='pureSelect'
        >
          {options.map((item, k) => (
            <MenuItem key={k} value={item}>
              <ListItemText primary={item.label ?? item.value} />
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default FilterSelective;
